import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  disabled?: boolean;
  children?: ReactNode;
  to: string;
}

const CustomLink: React.FC<Props> = ({ disabled, children, ...props }) => {
  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (disabled) {
      event.preventDefault();
    }
  };

  return (
    <Link {...props} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default CustomLink;
